import Cookies from "js-cookie";

export const NAYA_NAZIMABAD_HANDLE = "naya-nazimabad";
const VISIT_COOKIE = "landing_source";
const CHECKOUT_COOKIE = "checkout_landing_source";
const STORAGE_KEY = "landing_source";

function isNayaNazimabadPath(pathname = "") {
  return pathname.includes("/naya-nazimabad");
}

function hasVisitSource() {
  return (
    Cookies.get(VISIT_COOKIE) === NAYA_NAZIMABAD_HANDLE ||
    (typeof window !== "undefined" &&
      sessionStorage.getItem(STORAGE_KEY) === NAYA_NAZIMABAD_HANDLE)
  );
}

function setVisitSource() {
  Cookies.set(VISIT_COOKIE, NAYA_NAZIMABAD_HANDLE, { path: "/" });
  if (typeof window !== "undefined") {
    sessionStorage.setItem(STORAGE_KEY, NAYA_NAZIMABAD_HANDLE);
  }
}

export function captureNayaNazimabadSource(pathname) {
  if (typeof window === "undefined") return;
  if (isNayaNazimabadPath(pathname || window.location.pathname)) {
    setVisitSource();
  }
}

export function persistNayaNazimabadFromReferrer() {
  if (typeof window === "undefined") return;
  if (document.referrer?.includes("naya-nazimabad") || hasVisitSource()) {
    setVisitSource();
  }
}

export function markCheckoutFromNayaNazimabad() {
  if (hasVisitSource()) {
    Cookies.set(CHECKOUT_COOKIE, NAYA_NAZIMABAD_HANDLE, { path: "/" });
  }
}

export function isNayaNazimabadCheckout() {
  return (
    Cookies.get(CHECKOUT_COOKIE) === NAYA_NAZIMABAD_HANDLE || hasVisitSource()
  );
}
